(function () {
  "use strict";
  if (!document.body.classList.contains("pdp")) return;
  var mutationTimer,
    lastFocus,
    sizeListExpanded = !1,
    colorToastTimer,
    colorToastRequestedUntil = 0,
    colorToastShownPreview,
    selectedTierQuantity = 1,
    tierVariantId = "",
    paidTraffic = (function () {
      var params = new URLSearchParams(window.location.search),
        medium = (params.get("utm_medium") || "").toLowerCase(),
        source = (params.get("utm_source") || "").toLowerCase();
      return /paid|cpc|ppc|social/.test(medium) ||
        /facebook|instagram|meta/.test(source) ||
        [
          "fbclid",
          "gclid",
          "ttclid",
          "campaign_id",
          "adset_id",
          "ad_id",
          "hsa_cam",
        ].some(function (key) {
          return params.has(key);
        });
    })();
  function trackHotjar(name) {
    try {
      typeof window.hj == "function" && window.hj("event", name);
    } catch (error) {}
  }
  var syncing = !1, normalizeTimer;
  function setText(el, next) {
    el && el.textContent !== next && (el.textContent = next);
  }
  function setAttr(el, name, value) {
    el && el.getAttribute(name) !== value && el.setAttribute(name, value);
  }
  function setClass(el, name, on) {
    el && el.classList.contains(name) !== !!on &&
      el.classList.toggle(name, !!on);
  }
  function setProp(el, name, value) {
    el && el[name] !== value && (el[name] = value);
  }
  function q(selector, root) {
    return (root || document).querySelector(selector);
  }
  function qa(selector, root) {
    return Array.prototype.slice.call(
      (root || document).querySelectorAll(selector),
    );
  }
  function mainForm() {
    var picker = q('variant-picker[context="main_product"][form-id]') ||
        q('.product-info variant-picker[form-id]'),
      formId = picker && picker.getAttribute("form-id");
    return formId && document.getElementById(formId) ||
      q('form[action*="/cart/add"]');
  }
  function mainBuyButtons(form) {
    form = form || mainForm();
    var formId = form && form.getAttribute("id");
    if (!formId) return null;
    return qa("buy-buttons[form]", form).find(function (buttons) {
      return buttons.getAttribute("form") === formId;
    }) || null;
  }
  function mainQuantityInput() {
    var form = mainForm();
    return qa('input[name="quantity"]').filter(function (input) {
      return !form || input.form === form;
    })[0] || null;
  }
  function setMainQuantity(value) {
    var input = mainQuantityInput(), setter, nextValue = String(value);
    !input || input.value === nextValue ||
      (setter = Object.getOwnPropertyDescriptor(
        HTMLInputElement.prototype,
        "value",
      ),
        setter && setter.set
          ? setter.set.call(input, nextValue)
          : input.value = nextValue,
        input.setAttribute("value", nextValue),
        input.dispatchEvent(new Event("input", { bubbles: !0 })),
        input.dispatchEvent(new Event("change", { bubbles: !0 })));
  }
  function syncTierSelector() {
    var selector = q("[data-pdp-tier-selector]"), nextVariantId;
    selector &&
      (nextVariantId = selector.getAttribute("data-variant-id") || "",
        nextVariantId !== tierVariantId && (tierVariantId = nextVariantId),
        qa("[data-pdp-tier-quantity]", selector).forEach(function (button) {
          var quantity = Number(button.getAttribute("data-pdp-tier-quantity")),
            active = quantity === selectedTierQuantity;
          setClass(button, "is-active", active),
            setAttr(button, "aria-pressed", active ? "true" : "false");
        }),
        setMainQuantity(selectedTierQuantity));
  }
  function optionMap() {
    var form = mainForm(), map = {};
    return form && qa("input[data-option-position]").forEach(function (input) {
      if (input.form === form) {
        var position = input.getAttribute("data-option-position");
        (map[position] = map[position] || []).push(input);
      }
    }),
      map;
  }
  function sizePosition() {
    var map = optionMap(), positions = Object.keys(map).sort();
    if (positions.length < 2) return null;
    var position = positions[positions.length - 1];
    return map[position].length > 1 ? position : null;
  }
  function sizeInputs() {
    var position = sizePosition();
    return position ? optionMap()[position] || [] : [];
  }
  function sizeChosen() {
    var inputs = sizeInputs();
    return inputs.length
      ? inputs.some(function (input) {
        return input.checked;
      })
      : !0;
  }
  function sizeHint(show) {
    var hint = q("[data-pdp-size-hint]");
    hint &&
      (setProp(hint, "hidden", !show),
        show &&
        (hint.classList.remove("is-pulse"),
          hint.offsetWidth,
          hint.classList.add("is-pulse")));
  }
  function promptForSize() {
    var first = sizeInputs()[0];
    if (sizeHint(!0), !!first) {
      var target = first.closest("fieldset") || first;
      target.scrollIntoView({ block: "center", behavior: "smooth" }),
        window.setTimeout(function () {
          first.focus && first.focus({ preventScroll: !0 });
        }, 350);
    }
  }
  function markSingleOptions() {
    var map = optionMap();
    Object.keys(map).forEach(function (position) {
      var input = map[position][0],
        field = input &&
          (input.closest(".variant-picker__option") ||
            input.closest("fieldset"));
      field &&
        (map[position].length === 1
          ? setAttr(field, "data-pdp-single", "")
          : field.removeAttribute("data-pdp-single"));
    });
  }
  function setupSizeDisclosure() {
    var field = q("[data-pdp-size-option]"),
      isMobileSizeLayout =
        !1 /* Aufklappen abgeschaltet: alle neun Groessen stehen immer da */;
    if (field) {
      var values = q("[data-pdp-option-values]", field),
        inputs = qa("input[data-option-position]", field);
      if (!(!values || inputs.length <= 5)) {
        var canonicalSizes = ["XS", "S", "M", "L", "XL"],
          labels = inputs.map(function (input) {
            return input.nextElementSibling &&
                input.nextElementSibling.matches("label, a")
              ? input.nextElementSibling
              : null;
          }).filter(Boolean),
          availableNames = labels.map(function (label) {
            return label.textContent.trim().toUpperCase();
          }),
          isClothingScale = canonicalSizes.every(function (size) {
            return availableNames.indexOf(size) > -1;
          });
        if (isClothingScale) {
          var selectedExtended = inputs.some(function (input) {
              var label = input.nextElementSibling;
              return !input.checked || !label ? !1 : canonicalSizes.indexOf(
                label.textContent.trim().toUpperCase(),
              ) === -1;
            }),
            extendedSizes = labels.map(function (label) {
              return label.textContent.trim().toUpperCase();
            }).filter(function (size) {
              return canonicalSizes.indexOf(size) === -1;
            }),
            extendedSizeLabel = extendedSizes.length > 1
              ? extendedSizes[0] + "-" + extendedSizes[extendedSizes.length - 1]
              : extendedSizes[0];
          selectedExtended && (sizeListExpanded = !0),
            setClass(values, "pdp-size-values", !0),
            setClass(values, "is-pdp-size-expanded", sizeListExpanded),
            labels.forEach(function (label) {
              var size = label.textContent.trim().toUpperCase(),
                isExtra = canonicalSizes.indexOf(size) === -1,
                input = label.previousElementSibling,
                collapsed = !!(isMobileSizeLayout && !sizeListExpanded);
              setClass(label, "pdp-size-extra", isExtra),
                input && input.matches("input[data-option-position]") &&
                (isExtra
                  ? (setProp(input, "disabled", collapsed),
                    setProp(input, "hidden", collapsed))
                  : (setProp(input, "disabled", !1),
                    setProp(input, "hidden", !1)));
            });
          var toggle = q("[data-pdp-size-more]", values);
          toggle ||
          (toggle = document.createElement("button"),
            toggle.type = "button",
            toggle.className = "pdp-size-more",
            toggle.setAttribute("data-pdp-size-more", ""),
            values.appendChild(toggle)),
            setAttr(
              toggle,
              "aria-expanded",
              sizeListExpanded ? "true" : "false",
            ),
            setText(
              toggle,
              sizeListExpanded
                ? extendedSizeLabel + " ausblenden"
                : extendedSizeLabel + " anzeigen",
            );
        }
      }
    }
  }
  function humanList(items) {
    return items.length < 2
      ? items[0] || ""
      : items.length === 2
      ? items[0] + " und " + items[1]
      : items.slice(0, -1).join(", ") + " und " + items[items.length - 1];
  }
  function syncUnavailableSizes() {
    var field = q("[data-pdp-size-option]"),
      values = field && q("[data-pdp-option-values]", field),
      sizePos = sizePosition(),
      selectedColor = "",
      unavailable = [],
      note,
      noteText;
    !field || !values || !sizePos ||
      (Object.keys(optionMap()).some(function (position) {
        var selected, label;
        return position === sizePos ||
            (selected = optionMap()[position].filter(function (input) {
              return input.checked;
            })[0],
              label = selected && selected.nextElementSibling,
              !label)
          ? !1
          : (selectedColor = label.textContent.trim(), !!selectedColor);
      }),
        sizeInputs().forEach(function (input) {
          var label = input.nextElementSibling,
            isUnavailable =
              !!(label && label.classList.contains("is-disabled")),
            size = label && label.textContent.trim();
          label &&
            (setClass(label, "pdp-size-unavailable", isUnavailable),
              isUnavailable
                ? (unavailable.push(size),
                  setProp(input, "disabled", !0),
                  setAttr(input, "aria-disabled", "true"),
                  setAttr(label, "aria-disabled", "true"),
                  setAttr(
                    label,
                    "title",
                    size + " ist in " + selectedColor + " nicht verf\xFCgbar",
                  ))
                : (input.removeAttribute("aria-disabled"),
                  label.removeAttribute("aria-disabled"),
                  label.removeAttribute("title")));
        }),
        note = q("[data-pdp-size-availability]", values),
        note ||
        (note = document.createElement("p"),
          note.id = "asif-size-availability-note",
          note.className = "pdp-size-availability",
          note.setAttribute("data-pdp-size-availability", ""),
          note.setAttribute("role", "status"),
          note.setAttribute("aria-live", "polite"),
          values.appendChild(note)),
        setProp(note, "hidden", unavailable.length === 0),
        noteText = unavailable.length
          ? humanList(unavailable) +
            (unavailable.length === 1 ? " ist" : " sind") + " in " +
            selectedColor + " nicht verf\xFCgbar. Bitte w\xE4hle f\xFCr " +
            (unavailable.length === 1
              ? "diese Gr\xF6\xDFe"
              : "diese Gr\xF6\xDFen") +
            " eine andere Farbe."
          : "",
        setText(note, noteText),
        sizeInputs().forEach(function (input) {
          input.getAttribute("aria-disabled") === "true"
            ? setAttr(input, "aria-describedby", note.id)
            : input.getAttribute("aria-describedby") === note.id &&
              input.removeAttribute("aria-describedby");
        }));
  }
  function hideColorToast() {
    var preview = q("[data-pdp-variant-preview]");
    preview &&
      (preview.classList.remove("is-visible"),
        preview.setAttribute("aria-hidden", "true"),
        colorToastRequestedUntil = 0,
        colorToastShownPreview = null);
  }
  function showColorToast() {
    var preview = q("[data-pdp-variant-preview]");
    preview &&
      (preview === colorToastShownPreview &&
          preview.classList.contains("is-visible") ||
        (window.clearTimeout(colorToastTimer),
          preview.classList.remove("is-visible"),
          preview.offsetWidth,
          preview.classList.add("is-visible"),
          preview.setAttribute("aria-hidden", "false"),
          colorToastShownPreview = preview,
          colorToastTimer = window.setTimeout(hideColorToast, 3600)));
  }
  function requestColorToast() {
    colorToastRequestedUntil = Date.now() + 1200,
      window.setTimeout(function () {
        Date.now() <= colorToastRequestedUntil && showColorToast();
      }, 140);
  }
  function syncExpressCheckout(locked) {
    var form = mainForm();
    var buyBlock = mainBuyButtons(form);
    if (!buyBlock) return;
    qa(".shopify-payment-button", buyBlock).forEach(function (wrapper) {
      var lock = q(".pdp-express-lock", wrapper);
      locked && !lock
        ? (lock = document.createElement("button"),
          lock.type = "button",
          lock.className = "pdp-express-lock",
          lock.setAttribute(
            "aria-label",
            "Bitte zuerst eine Gr\xF6\xDFe w\xE4hlen",
          ),
          lock.innerHTML = "<span>Gr\xF6\xDFe w\xE4hlen</span>",
          lock.addEventListener("click", promptForSize),
          wrapper.appendChild(lock))
        : !locked && lock && lock.remove(),
        setClass(wrapper, "is-pdp-locked", locked),
        setAttr(wrapper, "aria-disabled", locked ? "true" : "false"),
        qa("iframe, button, input, a", wrapper).forEach(function (control) {
          if (!control.classList.contains("pdp-express-lock")) {
            if (locked) {
              control.hasAttribute("data-pdp-tabindex") ||
              control.setAttribute(
                "data-pdp-tabindex",
                control.getAttribute("tabindex") || "",
              ), setAttr(control, "tabindex", "-1");
            } else if (control.hasAttribute("data-pdp-tabindex")) {
              var original = control.getAttribute("data-pdp-tabindex");
              original === ""
                ? control.removeAttribute("tabindex")
                : setAttr(control, "tabindex", original),
                control.removeAttribute("data-pdp-tabindex");
            }
          }
        });
    });
  }
  function selectedVariantAvailable() {
    var picker = q('variant-picker[context="main_product"][form-id]'),
      data = picker && q("script[data-variant]", picker);
    if (!data) return null;
    try {
      return JSON.parse(data.textContent || "{}").available !== !1;
    } catch (error) {
      return null;
    }
  }
  function syncProductSubmit(needsSize) {
    var form = mainForm(),
      submit = form && q('button[type="submit"], input[type="submit"]', form);
    if (!(!form || !submit)) {
      if (submit.hasAttribute("data-asif-sync-disabled")) return;
      if (setClass(form, "asif-size-required", needsSize), needsSize) {
        setProp(submit, "disabled", !1);
        return;
      }
      if (selectedVariantAvailable() === !0) {
        setProp(submit, "disabled", !1);
        var describedBy = submit.getAttribute("aria-describedby") || "";
        describedBy.indexOf("asif-size-error") > -1 &&
          submit.removeAttribute("aria-describedby");
      }
      qa(".asif-size-error", form).forEach(function (error) {
        setProp(error, "hidden", !0);
      });
    }
  }
  function normalizePunctuation() {
    var root = q(".pdp"),
      walker,
      node,
      parent,
      enDash = "\u2013",
      emDash = "\u2014";
    if (!(!root || !document.createTreeWalker)) {
      for (
        walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
        node = walker.nextNode();
      ) {
        parent = node.parentElement,
          !(!parent || parent.closest("script, style, noscript, textarea")) &&
          (node.nodeValue.indexOf(enDash) > -1 ||
            node.nodeValue.indexOf(emDash) > -1) &&
          (node.nodeValue = node.nodeValue.split(enDash).join("-").split(emDash)
            .join("-"));
      }
    }
  }
  function queueNormalizePunctuation() {
    window.clearTimeout(normalizeTimer),
      normalizeTimer = window.setTimeout(normalizePunctuation, 120);
  }
  function syncPaidContext() {
    var paidContext = q("[data-pdp-paid-context]");
    !paidTraffic || !paidContext ||
      (setProp(paidContext, "hidden", !1),
        setClass(document.body, "pdp-paid-traffic", !0));
  }
  function sync() {
    if (!syncing) {
      syncing = !0;
      try {
        var needsSize = sizeInputs().length > 0 && !sizeChosen();
        setClass(document.body, "pdp-needs-size", needsSize),
          markSingleOptions(),
          setupSizeDisclosure(),
          syncUnavailableSizes(),
          syncProductSubmit(needsSize),
          syncExpressCheckout(needsSize),
          syncTierSelector(),
          needsSize || sizeHint(!1),
          markSizeRow(),
          syncPaidContext();
      } finally {
        window.setTimeout(function () {
          syncing = !1;
        }, 0);
      }
    }
  }
  function isProductSubmit(button) {
    if (!button) return !1;
    var form = button.form;
    return !form && button.getAttribute("form") &&
      (form = document.getElementById(button.getAttribute("form"))),
      !!(form && form.action && form.action.indexOf("/cart/add") > -1);
  }
  function isMainProductSubmit(button) {
    return isProductSubmit(button) &&
      !!button.closest(".product-info") &&
      !button.closest("[data-pdp-quick-addon]") &&
      !button.closest(".product-sticky-bar");
  }
  document.addEventListener("click", function (event) {
    var tierButton = event.target.closest &&
        event.target.closest("[data-pdp-tier-quantity]"),
      quantity;
    if (tierButton) {
      event.preventDefault(),
        quantity = Number(tierButton.getAttribute("data-pdp-tier-quantity")) ||
          1,
        selectedTierQuantity = quantity,
        setMainQuantity(quantity),
        syncTierSelector(),
        trackHotjar(
          quantity === 1
            ? "cro_pdp_quantity_single_selected"
            : "cro_pdp_quantity_tier_selected",
        );
      return;
    }
  }, !0),
    document.addEventListener("click", function (event) {
      var button = event.target.closest &&
        event.target.closest('button[type="submit"]');
      !button || !isMainProductSubmit(button) ||
        (setMainQuantity(selectedTierQuantity),
          trackHotjar("cro_pdp_add_to_cart_attempt"),
          !sizeChosen() &&
          (trackHotjar("cro_pdp_size_blocked"),
            event.preventDefault(),
            event.stopImmediatePropagation(),
            promptForSize()));
    }, !0),
    document.addEventListener("change", function (event) {
      var input = event.target;
      !input || !input.matches ||
        !input.matches("input[data-option-position]") ||
        !input.closest('variant-picker[context="main_product"]') ||
        (input.getAttribute("data-option-position") === sizePosition()
          ? (sizeHint(!1), trackHotjar("cro_pdp_size_changed"))
          : trackHotjar("cro_pdp_variant_changed"),
          event.isTrusted && input.closest("[data-pdp-color-option]") &&
          (trackHotjar("cro_pdp_color_changed"), requestColorToast()),
          window.setTimeout(sync, 0),
          queueNormalizePunctuation());
    }, !0);
  function openSizeDrawer(trigger) {
    var drawer = q("[data-pdp-drawer]");
    if (drawer) {
      lastFocus = trigger || document.activeElement,
        drawer.hidden = !1,
        drawer.setAttribute("aria-hidden", "false"),
        document.documentElement.classList.add("pdp-drawer-open");
      var close = q("[data-pdp-close]", drawer);
      close && close.focus({ preventScroll: !0 });
    }
  }
  function closeSizeDrawer() {
    var drawer = q("[data-pdp-drawer]");
    !drawer || drawer.hidden ||
      (drawer.hidden = !0,
        drawer.setAttribute("aria-hidden", "true"),
        document.documentElement.classList.remove("pdp-drawer-open"),
        lastFocus && lastFocus.isConnected && lastFocus.focus &&
        lastFocus.focus({ preventScroll: !0 }));
  }
  document.addEventListener("click", function (event) {
    var unavailableSize = event.target.closest &&
      event.target.closest("[data-pdp-size-option] .pdp-size-unavailable");
    if (unavailableSize) {
      var availabilityNote = q("[data-pdp-size-availability]");
      event.preventDefault(),
        event.stopImmediatePropagation(),
        trackHotjar("cro_pdp_size_unavailable"),
        availabilityNote &&
        (availabilityNote.classList.remove("is-pulse"),
          availabilityNote.offsetWidth,
          availabilityNote.classList.add("is-pulse"));
      return;
    }
    var sizeMore = event.target.closest &&
      event.target.closest("[data-pdp-size-more]");
    if (sizeMore) {
      event.preventDefault(),
        sizeListExpanded = !sizeListExpanded,
        setupSizeDisclosure();
      return;
    }
    var colorPreview = event.target.closest &&
      event.target.closest("[data-pdp-variant-preview]");
    if (colorPreview) {
      event.preventDefault(), hideColorToast();
      var zoomButton = q(
        ".product-gallery__zoom-button:not(.product-gallery__zoom-button--hidden)",
      );
      if (zoomButton) zoomButton.click();
      else {
        var gallery = q(".product-gallery");
        gallery &&
          gallery.scrollIntoView({ block: "start", behavior: "smooth" });
      }
      return;
    }
    var open = event.target.closest &&
      event.target.closest('[data-pdp-open="size"]');
    if (open) {
      event.preventDefault(), openSizeDrawer(open);
      return;
    }
    event.target.closest && event.target.closest("[data-pdp-close]") &&
      (event.preventDefault(), closeSizeDrawer());
  }),
    document.addEventListener("keydown", function (event) {
      event.key === "Escape" && closeSizeDrawer();
    });
  function shippingNudge() {
    if (typeof window.asifPdpRefreshShipping === "function") {
      window.asifPdpRefreshShipping();
    }
  }
  function markSizeRow() {
    var chosen = sizeInputs().filter(function (input) {
        return input.checked;
      })[0],
      label = chosen && (chosen.nextElementSibling || {}).textContent;
    if (
      qa(".pdp-sizetable tr").forEach(function (row) {
        row.removeAttribute("data-pdp-current");
      }), !!label
    ) {
      var wanted = label.trim().toLowerCase();
      qa(".pdp-sizetable tbody tr").forEach(function (row) {
        var heading = q("th", row);
        heading && heading.textContent.trim().toLowerCase() === wanted &&
          setAttr(row, "data-pdp-current", "");
      });
    }
  }
  var observer = new MutationObserver(function () {
    window.clearTimeout(mutationTimer),
      mutationTimer = window.setTimeout(function () {
        sync(), Date.now() <= colorToastRequestedUntil && showColorToast();
      }, 80);
  });
  function boot() {
    var paidContext = q("[data-pdp-paid-context]"),
      sizeLayoutMedia = window.matchMedia &&
        window.matchMedia("(max-width: 699px)");
    paidTraffic && paidContext &&
    (syncPaidContext(), trackHotjar("cro_pdp_paid_landing")),
      sync(),
      normalizePunctuation(),
      window.setTimeout(function () {
        sync(), normalizePunctuation();
      }, 600),
      shippingNudge(),
      document.addEventListener("variant:change", queueNormalizePunctuation),
      document.addEventListener("product:rerender", queueNormalizePunctuation),
      sizeLayoutMedia && sizeLayoutMedia.addEventListener &&
      sizeLayoutMedia.addEventListener("change", sync),
      observer.observe(
        q('product-rerender[id^="product-info-"]') || q(".product") ||
          document.body,
        { childList: true, subtree: true },
      );
  }
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", boot, { once: !0 })
    : boot();
})(),
  (function () {
    "use strict";
    if (!document.body.classList.contains("pdp")) return;
    var colorParamApplied = !1,
      explicitSizeRequired = !1,
      sizeWasChosenByShopper = !1,
      syncTimer = 0,
      lifestyleMediaId = "50794320757002",
      lifestyleProductHandle = "espresso-martini-bio-tee-liquid-joy";
    function q(selector, root) {
      return (root || document).querySelector(selector);
    }
    function qa(selector, root) {
      return Array.prototype.slice.call(
        (root || document).querySelectorAll(selector),
      );
    }
    function mainPicker() {
      return q('variant-picker[context="main_product"][form-id]');
    }
    function mainForm() {
      var picker = mainPicker(),
        formId = picker && picker.getAttribute("form-id");
      return formId &&
          (document.getElementById(formId) ||
            document.forms.namedItem(formId)) || null;
    }
    function sizeField() {
      var picker = mainPicker();
      return explicitSizeRequired && picker
        ? q("[data-pdp-size-option]", picker)
        : null;
    }
    function sizeInputs() {
      var field = sizeField(), form = mainForm();
      return field && form
        ? qa("input[data-option-position]", field).filter(function (input) {
          return input.form === form;
        })
        : [];
    }
    function sizePending() {
      var inputs = sizeInputs();
      return inputs.length > 0 && !inputs.some(function (input) {
        return input.checked;
      });
    }
    function clearImplicitSize() {
      sizeWasChosenByShopper || sizeInputs().forEach(function (input) {
        input.checked = !1;
      });
    }
    function setAttr(element, name, value) {
      element && element.getAttribute(name) !== value &&
        element.setAttribute(name, value);
    }
    function ensureSizeHint() {
      var field = sizeField(), hint = q("[data-pdp-size-hint]");
      return field
        ? (hint ||
          (hint = document.createElement("p"),
            hint.className = "pdp-hint pdp-hint--error",
            hint.setAttribute("data-pdp-size-hint", ""),
            hint.setAttribute("role", "alert"),
            hint.setAttribute("aria-live", "polite"),
            hint.hidden = !0,
            hint.textContent = "Bitte w\xE4hl zuerst eine Gr\xF6\xDFe.",
            field.insertAdjacentElement("afterend", hint)),
          hint)
        : null;
    }
    function promptForSize() {
      var field = sizeField(), first = sizeInputs()[0], hint = ensureSizeHint();
      hint &&
      (hint.hidden = !1,
        hint.classList.remove("is-pulse"),
        hint.offsetWidth,
        hint.classList.add("is-pulse")),
        field && field.scrollIntoView({ block: "center", behavior: "smooth" }),
        window.setTimeout(function () {
          first && first.focus && first.focus({ preventScroll: !0 });
        }, 350);
    }
    function syncSizeGate() {
      var form = mainForm(), pending = sizePending();
      if (form && pending) {
        var variantInput = q('input[name="id"]', form);
        if (variantInput) {
          variantInput.value = "";
          variantInput.disabled = !0;
        }
      }
      if (form) {
        var formId = form.getAttribute("id"),
          buyBlock = formId && qa("buy-buttons[form]", form).find(
            function (buttons) {
              return buttons.getAttribute("form") === formId;
            },
          );
        (buyBlock ? qa(".shopify-payment-button", buyBlock) : []).forEach(
          function (payment) {
            if (pending) {
              payment.setAttribute("data-pdp-size-inert", "");
              payment.hidden = !0;
              payment.setAttribute("inert", "");
              payment.setAttribute("aria-hidden", "true");
            } else if (payment.hasAttribute("data-pdp-size-inert")) {
              payment.hidden = !1;
              if (!payment.hasAttribute("data-asif-sync-inert")) {
                payment.removeAttribute("inert");
                payment.removeAttribute("aria-hidden");
              }
              payment.removeAttribute("data-pdp-size-inert");
            }
          },
        );
      }
      if (
        document.body.classList.toggle("pdp-needs-size", pending),
          !!form && (qa('button[type="submit"]').forEach(function (button) {
            if (button.form === form) {
              if (pending) {
                !button.hasAttribute("data-asif-sync-disabled") &&
                  button.disabled && (button.disabled = !1),
                  setAttr(button, "aria-disabled", "true"),
                  button.textContent.trim() !== "Bitte Gr\xF6\xDFe w\xE4hlen" &&
                  (button.textContent = "Bitte Gr\xF6\xDFe w\xE4hlen"),
                  button.classList.add("asif-size-gated");
              } else {
                if (
                  !button.hasAttribute("data-asif-sync-disabled") &&
                  button.getAttribute("aria-disabled") === "true" &&
                  button.removeAttribute("aria-disabled"),
                    button.textContent.trim() === "Bitte Gr\xF6\xDFe w\xE4hlen"
                ) {
                  var chosen = sizeInputs().filter(function (input) {
                      return input.checked;
                    })[0],
                    chosenLabel = chosen && chosen.nextElementSibling
                      ? chosen.nextElementSibling.textContent.trim()
                      : "";
                  button.textContent =
                    button.closest("product-sticky-bar") && chosenLabel
                      ? chosenLabel + " \xB7 In den Warenkorb"
                      : "In den Warenkorb";
                }
                button.classList.remove("asif-size-gated");
              }
            }
          }),
            !pending)
      ) {
        var hint = q("[data-pdp-size-hint]");
        hint && (hint.hidden = !0);
      }
    }
    function normalizedText(value) {
      return (value || "").trim().toLocaleLowerCase("de-DE");
    }
    function colorField() {
      var picker = mainPicker();
      return picker && q("[data-pdp-color-option]", picker);
    }
    function inputLabel(input) {
      var label = input && input.nextElementSibling;
      return label && label.matches("label,a")
        ? normalizedText(label.textContent)
        : "";
    }
    function requestedColor() {
      return normalizedText(
        new URLSearchParams(window.location.search).get("farbe"),
      );
    }
    function isLifestyleProduct() {
      return window.location.pathname.indexOf(
        "/products/" + lifestyleProductHandle,
      ) > -1;
    }
    function applyColorParam() {
      if (!colorParamApplied) {
        var wanted = requestedColor(), field = colorField();
        if (!(!wanted || !field)) {
          var inputs = qa("input[data-option-position]", field),
            match = inputs.filter(function (input) {
              return inputLabel(input) === wanted;
            })[0];
          if (match && (colorParamApplied = !0, !match.checked)) {
            inputs.forEach(function (input) {
              input.checked = !1;
            }), match.checked = !0;
            var currentValue = q(".variant-picker__option-info span", field);
            if (
              currentValue &&
              (currentValue.textContent = (match.nextElementSibling &&
                  match.nextElementSibling.textContent || "Black").trim()),
                isLifestyleProduct() && wanted === "black"
            ) return;
            match.dispatchEvent(new Event("change", { bubbles: !0 }));
          }
        }
      }
    }
    function currentColorIsBlack() {
      var selected = colorField() &&
        q("input[data-option-position]:checked", colorField());
      return inputLabel(selected) === "black";
    }
    function isLifestyleLanding() {
      return isLifestyleProduct() && requestedColor() === "black" &&
        currentColorIsBlack();
    }
    function showLifestyleMedia() {
      if (isLifestyleLanding()) {
        var gallery = q("product-gallery"),
          target = gallery &&
            q(
              '.product-gallery__media[data-media-id="' + lifestyleMediaId +
                '"]',
              gallery,
            ),
          thumbnail = gallery &&
            q(
              '.product-gallery__thumbnail[data-media-id="' + lifestyleMediaId +
                '"]',
              gallery,
            ),
          galleryCarousel = gallery && q(".product-gallery__carousel", gallery),
          carousel = gallery && gallery.carousel;
        if (target && galleryCarousel) {
          galleryCarousel.scrollLeft = target.offsetLeft,
            qa(".product-gallery__thumbnail", gallery).forEach(function (item) {
              item.setAttribute(
                "aria-current",
                item === thumbnail ? "true" : "false",
              );
            });
          return;
        }
        if (
          target && carousel && carousel.cells &&
          typeof carousel.select == "function"
        ) {
          var index = carousel.cells.indexOf(target);
          index > -1 && carousel.select(index, { instant: !0 });
          return;
        }
        thumbnail && thumbnail.getAttribute("aria-current") !== "true" &&
          thumbnail.click();
      }
    }
    function revealLifestyleMedia() {
      showLifestyleMedia();
    }
    function clearIncompleteVariantUrl() {
      if (sizePending()) {
        var url = new URL(window.location.href);
        url.searchParams.has("variant") &&
          (url.searchParams.delete("variant"),
            window.history.replaceState(
              { path: url.toString() },
              "",
              url.toString(),
            ));
      }
    }
    function syncPreviewOffset() {
      var preview = q("[data-pdp-variant-preview]");
      if (preview) {
        var stickyBottom = 0;
        qa(".shopify-section-group-header-group").forEach(function (section) {
          var style = window.getComputedStyle(section),
            rect = section.getBoundingClientRect();
          (style.position === "sticky" || style.position === "fixed") &&
            rect.height > 0 && rect.bottom > 0 &&
            rect.top < window.innerHeight &&
            (stickyBottom = Math.max(stickyBottom, rect.bottom));
        }),
          preview.style.setProperty(
            "--pdp-preview-top",
            Math.ceil(stickyBottom + 12) + "px",
          );
      }
    }
    function queueSync() {
      window.clearTimeout(syncTimer),
        syncTimer = window.setTimeout(function () {
          clearImplicitSize(),
            syncSizeGate(),
            clearIncompleteVariantUrl(),
            syncPreviewOffset(),
            showLifestyleMedia();
        }, 120);
    }
    function boot() {
      explicitSizeRequired = !!q(
        '[data-pdp-size-selection="required"]',
        mainPicker(),
      ),
        ensureSizeHint(),
        clearImplicitSize(),
        syncSizeGate(),
        syncPreviewOffset(),
        applyColorParam(),
        window.setTimeout(showLifestyleMedia, 0),
        window.setTimeout(showLifestyleMedia, 250),
        window.setTimeout(showLifestyleMedia, 700),
        window.setTimeout(revealLifestyleMedia, 980);
      var productObserverRoot = q('product-rerender[id^="product-info-"]') ||
        q(".product-info") || document.body;
      new MutationObserver(function () {
        clearImplicitSize(),
          syncSizeGate(),
          clearIncompleteVariantUrl(),
          syncPreviewOffset(),
          queueSync();
      }).observe(productObserverRoot, { childList: !0, subtree: !0 }),
        document.addEventListener("variant:change", function () {
          queueSync(), window.setTimeout(showLifestyleMedia, 220);
        }),
        document.addEventListener("change", function (event) {
          !event.target || !event.target.matches ||
            !event.target.matches("input[data-option-position]") ||
            (explicitSizeRequired &&
              event.target.closest('variant-picker[context="main_product"]') &&
              event.target.closest("[data-pdp-size-option]") &&
              (sizeWasChosenByShopper = !0),
              syncPreviewOffset(),
              queueSync());
        }, !0),
        window.addEventListener("resize", syncPreviewOffset, { passive: !0 }),
        document.addEventListener("click", function (event) {
          var button = event.target.closest &&
              event.target.closest('button[type="submit"]'),
            form = mainForm();
          !button || button.closest(".product-sticky-bar") || !form ||
            button.form !== form || !sizePending() ||
            (event.preventDefault(),
              event.stopImmediatePropagation(),
              promptForSize());
        }, !0),
        document.addEventListener("submit", function (event) {
          var form = mainForm();
          if (!form || event.target !== form || !sizePending()) return;
          event.preventDefault(),
            event.stopImmediatePropagation(),
            promptForSize();
        }, !0);
    }
    document.readyState === "loading"
      ? document.addEventListener("DOMContentLoaded", boot, { once: !0 })
      : boot();
  })();
//# sourceMappingURL=/cdn/shop/t/194/assets/asif-pdp.js.map?v=1385951684461818241786707197

/* --- Schritt 16, 17.08.2026 -----------------------------------------
   Tipp aufs Bild und Klick auf den eckigen ZOOM-Knopf oeffnen die
   Lightbox mit korrektem Index. theme.js steigt in onCarouselClick_fn
   unterhalb von 1000px sofort aus, mobil passierte beim Tippen nichts.
------------------------------------------------------------------- */
document.addEventListener("click", function (e) {
  var trigger = e.target.closest(".pdp .asif-media-zoom");
  var img = trigger
    ? null
    : e.target.closest(".pdp .product-gallery__carousel img");
  if (!trigger && !img) return;
  /* Bildklick auf Desktop macht theme.js schon selbst */
  if (img && window.matchMedia("screen and (min-width: 1000px)").matches) {
    return;
  }

  var cell = (trigger || img).closest(".product-gallery__media");
  if (!cell || cell.getAttribute("data-media-type") !== "image") return;
  var gallery = cell.closest("product-gallery");
  if (!gallery || !gallery.hasAttribute("allow-zoom")) return;

  var imageCells = Array.prototype.filter.call(
    gallery.querySelectorAll(
      '.product-gallery__media[data-media-type="image"]:not([hidden])',
    ),
    function (c) {
      return c.getAttribute("data-media-type") === "image";
    },
  );
  gallery.dispatchEvent(
    new CustomEvent("lightbox:open", {
      bubbles: true,
      detail: { index: imageCells.indexOf(cell) },
    }),
  );
});

/* --- Thumbnail-Sprung im gestapelten Desktop-Layout 17.08.2026 -------
   Im Layout "grid" liegen die Bilder untereinander, das Karussell hat
   also keine horizontale Scrollbreite. carousel.select() bewegt dann
   nichts, der Klick auf ein Thumbnail lief ins Leere. Hier wird statt
   dessen die passende Zelle angesprungen. Den Abstand zum klebrigen
   Kopf liefert scroll-margin-block-start aus asif-pdp.css.
------------------------------------------------------------------- */
document.addEventListener("click", function (e) {
  var thumb = e.target.closest(".pdp .product-gallery__thumbnail");
  if (!thumb) return;
  var gallery = thumb.closest("product-gallery");
  var carousel = gallery && gallery.querySelector(".product-gallery__carousel");
  if (!carousel) return;
  /* Nur wenn wirklich gestapelt: kein horizontaler Scrollweg vorhanden */
  if (carousel.scrollWidth - carousel.clientWidth > 2) return;

  var id = thumb.getAttribute("data-media-id");
  var cell = id &&
    carousel.querySelector(
      '.product-gallery__media[data-media-id="' + id + '"]',
    );
  if (!cell) return;
  /* Erst im naechsten Tick springen: der Standardhandler des Themes
     laeuft danach und wuerde eine weiche Bewegung sonst abbrechen. */
  setTimeout(function () {
    cell.scrollIntoView({ behavior: "smooth", block: "start" });
  }, 0);
}, true);

/* --- Kopfhoehe messen 17.08.2026 -------------------------------------
   Vier Stellen im Theme rechnen die Kopfhoehe getrennt aus. Ab hier
   gilt nur noch der gemessene Wert. --sticky-area-height bleibt als
   Rueckfall im CSS stehen, wird aber nie mehr direkt benutzt.
--------------------------------------------------------------------- */
(function () {
  "use strict";
  if (!document.body || !document.body.classList.contains("pdp")) return;

  var root = document.documentElement;

  window.asifStickyTop = function () {
    var top = 0;
    Array.prototype.forEach.call(
      document.querySelectorAll(".shopify-section-group-header-group"),
      function (sec) {
        var st = window.getComputedStyle(sec);
        var r = sec.getBoundingClientRect();
        if (
          (st.position === "sticky" || st.position === "fixed") &&
          r.height > 0 && r.bottom > 0 && r.top < window.innerHeight
        ) {
          top = Math.max(top, r.bottom);
        }
      },
    );
    if (top > 0) {
      root.style.setProperty("--asif-sticky-top", Math.ceil(top) + "px");
    }
    return top;
  };

  /* Der Kopf ist nicht ueberall gleich hoch: der Ankuendigungsbalken
     verschwindet beim Scrollen, der Header schrumpft. Wurde die Hoehe nur
     beim Laden gemessen, klebte die Kaufspalte danach ein paar Pixel zu
     hoch und die oberste Zeile verschwand hinter dem Kopf. Deshalb messen
     wir auch beim Scrollen, gedrosselt auf einen Frame. */
  var laeuft = false;
  function nachmessen() {
    if (laeuft) return;
    laeuft = true;
    window.requestAnimationFrame(function () {
      laeuft = false;
      window.asifStickyTop();
    });
  }

  function boot() {
    window.asifStickyTop();
    window.addEventListener("resize", nachmessen, { passive: true });
    window.addEventListener("scroll", nachmessen, { passive: true });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(window.asifStickyTop);
    }
  }

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", boot, { once: true })
    : boot();
})();

/* --- PDP Conversion Controller 18.08.2026 ---------------------------
   Kleine, delegierte Controller fuer Galerie-Status, Versandfortschritt,
   mobile Detailtiefe und die gemeinsame Sticky-Hoehe. Keine zusaetzliche
   Netzwerkressource und keine Storefront-Copy aus Kampagnenparametern.
--------------------------------------------------------------------- */
(function () {
  "use strict";
  if (!document.body || !document.body.classList.contains("pdp")) return;

  function one(selector, root) {
    return (root || document).querySelector(selector);
  }

  function all(selector, root) {
    return Array.prototype.slice.call(
      (root || document).querySelectorAll(selector),
    );
  }

  function pad(number) {
    return String(Math.max(0, number || 0)).padStart(2, "0");
  }

  function selectedColor() {
    var picker = one('variant-picker[context="main_product"]');
    var field = picker && one("[data-pdp-color-option]", picker);
    var input = field && one("input[data-option-position]:checked", field);
    var label = input && input.nextElementSibling;
    return label ? label.textContent.trim() : "";
  }

  function galleryController(gallery) {
    var status = one("[data-pdp-gallery-status]", gallery);
    var carousel = one(".product-gallery__carousel", gallery);
    if (!status || !carousel) return;

    var pending = false;

    function visibleCells(includeSwitch) {
      return all(".product-gallery__media:not([hidden])", gallery).filter(
        function (cell) {
          return includeSwitch ||
            cell.getAttribute("data-media-type") !== "switch";
        },
      );
    }

    function currentCell(cells) {
      var currentThumb = one(
        '.product-gallery__thumbnail[aria-current="true"]:not([hidden])',
        gallery,
      );
      var thumbId = currentThumb && currentThumb.getAttribute("data-media-id");
      var byThumb = thumbId && cells.find(function (cell) {
        return cell.getAttribute("data-media-id") === thumbId;
      });
      if (byThumb) return byThumb;

      var left = carousel.getBoundingClientRect().left;
      var nearest = cells.reduce(function (best, cell) {
        var distance = Math.abs(cell.getBoundingClientRect().left - left);
        return !best || distance < best.distance
          ? { cell: cell, distance: distance }
          : best;
      }, null);
      return nearest ? nearest.cell : cells[0];
    }

    function setText(node, value) {
      if (node && node.textContent !== value) node.textContent = value;
    }

    function setAttribute(node, name, value) {
      if (node && node.getAttribute(name) !== value) {
        node.setAttribute(name, value);
      }
    }

    function setHidden(node, hidden) {
      if (node && node.hidden !== hidden) node.hidden = hidden;
    }

    function updateAccessibleLabels(cells, color) {
      cells.forEach(function (cell, cellIndex) {
        var position = cellIndex + 1;
        var label = "Produktbild " + position + " von " + cells.length +
          (color ? ", Farbe " + color : "");
        setAttribute(cell, "aria-label", label);
        var mediaId = cell.getAttribute("data-media-id");
        if (!mediaId) return;
        all(
          '.product-gallery__thumbnail[data-media-id="' + mediaId + '"]',
          gallery,
        ).forEach(function (thumb) {
          setAttribute(thumb, "aria-label", label);
          var image = one("img", thumb);
          if (image && image.getAttribute("alt") !== "") {
            image.setAttribute("alt", "");
          }
        });
        all(
          '.page-dots button[data-media-id="' + mediaId + '"]',
          gallery,
        ).forEach(function (dot) {
          var dotLabel = one(".sr-only", dot);
          setText(dotLabel, label);
          setAttribute(dot, "aria-label", label);
        });
      });

      all('[data-media-type="switch"]:not([hidden])', gallery).forEach(
        function (switchCell) {
          var targetButton = one("[data-pdp-alt-color]:not([hidden])", switchCell);
          var target = targetButton &&
            targetButton.getAttribute("data-pdp-alt-color") || "";
          setAttribute(
            switchCell,
            "aria-label",
            "Farbe wechseln" + (target ? " zu " + target : ""),
          );
        },
      );
      all("[data-pdp-alt-color-thumb]:not([hidden])", gallery).forEach(
        function (thumb) {
          var target = thumb.getAttribute("data-pdp-alt-color-thumb") || "";
          setAttribute(
            thumb,
            "aria-label",
            "Farbe wechseln" + (target ? " zu " + target : ""),
          );
        },
      );
      all('.page-dots button[data-media-type="switch"]', gallery).forEach(
        function (dot) {
          var visibleSwitch = one(
            '[data-media-type="switch"] [data-pdp-alt-color]:not([hidden])',
            gallery,
          );
          var target = visibleSwitch &&
            visibleSwitch.getAttribute("data-pdp-alt-color") || "";
          var label = "Farbe wechseln" + (target ? " zu " + target : "");
          setText(one(".sr-only", dot), label);
          setAttribute(dot, "aria-label", label);
        },
      );
    }

    function update() {
      pending = false;
      var cells = visibleCells(false);
      var allVisible = visibleCells(true);
      var current = currentCell(allVisible);
      var index = Math.max(0, cells.indexOf(current)) + 1;
      var currentNode = one("[data-pdp-gallery-current]", status);
      var totalNode = one("[data-pdp-gallery-total]", status);
      var colorNode = one("[data-pdp-gallery-color]", status);
      var countNode = one("[data-pdp-gallery-count]", status);
      var switchNode = one("[data-pdp-gallery-switch]", status);
      var separatorNode = one("[data-pdp-gallery-separator]", status);
      var color = selectedColor();
      var isSwitch = current &&
        current.getAttribute("data-media-type") === "switch";
      var switchButton = isSwitch &&
        one("[data-pdp-alt-color]:not([hidden])", current);
      var switchTarget = switchButton &&
        switchButton.getAttribute("data-pdp-alt-color") || "";
      setHidden(countNode, isSwitch);
      setHidden(switchNode, !isSwitch);
      setHidden(separatorNode, isSwitch || !color);
      setHidden(colorNode, isSwitch);
      setText(currentNode, pad(index));
      setText(totalNode, pad(cells.length));
      setText(
        switchNode,
        "Farbe wechseln" + (switchTarget ? " zu " + switchTarget : ""),
      );
      setText(colorNode, color);
      setAttribute(
        status,
        "aria-label",
        isSwitch
          ? "Farbe wechseln" + (switchTarget ? " zu " + switchTarget : "")
          : "Produktbild " + index + " von " + cells.length +
            (color ? ", Farbe " + color : ""),
      );
      updateAccessibleLabels(cells, color);
    }

    function queue() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(update);
    }

    carousel.addEventListener("scroll", queue, { passive: true });
    carousel.addEventListener("carousel:change", queue);
    carousel.addEventListener("carousel:settle", queue);
    carousel.addEventListener("carousel:filter", queue);
    new MutationObserver(queue).observe(gallery, {
      subtree: true,
      attributes: true,
      attributeFilter: ["hidden", "aria-current"],
    });
    document.addEventListener("variant:change", function () {
      window.setTimeout(queue, 40);
    });
    document.addEventListener("product:rerender", function () {
      queue();
      window.setTimeout(queue, 80);
    });
    update();
  }

  function setupSpecsDisclosure() {
    var query = window.matchMedia("(max-width: 699px)");
    var disclosures = all("[data-pdp-specs-disclosure][data-collapse-mobile]");
    if (!disclosures.length) return;
    function sync() {
      disclosures.forEach(function (details) {
        details.open = !query.matches;
      });
    }
    disclosures.forEach(function (details) {
      var summary = one("summary", details);
      if (summary) {
        summary.addEventListener("click", function (event) {
          if (!query.matches) {
            event.preventDefault();
            details.open = true;
          }
        });
      }
      details.addEventListener("toggle", function () {
        if (!query.matches && !details.open) details.open = true;
      });
    });
    sync();
    if (query.addEventListener) query.addEventListener("change", sync);
  }

  function setupShippingProgress() {
    var initialHost = one("[data-pdp-shipping-nudge]");
    if (!initialHost) return;
    var threshold = Number(initialHost.getAttribute("data-threshold")) || 4500;
    var revision = 0;
    var controller;
    var lastCart = null;
    var refreshTimer = 0;

    function money(cents, currency) {
      return new Intl.NumberFormat(document.documentElement.lang || "de-DE", {
        style: "currency",
        currency: currency || "EUR",
      }).format(Math.max(0, cents) / 100);
    }

    function shippingEligibleTotal(cart) {
      if (!cart || !Array.isArray(cart.items)) return 0;
      var itemTotal = cart.items.reduce(function (sum, item) {
        return item && item.requires_shipping
          ? sum + Math.max(Number(item.final_line_price) || 0, 0)
          : sum;
      }, 0);
      var cartDiscount = Array.isArray(cart.cart_level_discount_applications)
        ? cart.cart_level_discount_applications.reduce(function (sum, discount) {
          return sum + Math.max(
            Number(discount && discount.total_allocated_amount) || 0,
            0,
          );
        }, 0)
        : 0;
      return Math.max(itemTotal - cartDiscount, 0);
    }

    function paint(cart) {
      var host = one("[data-pdp-shipping-nudge]");
      if (!host) return;
      var total = shippingEligibleTotal(cart);
      var currency = cart && cart.currency || "EUR";
      var missing = Math.max(threshold - total, 0);
      var progress = Math.min(total / threshold, 1);
      var label = one("[data-pdp-shipping-label]", host);
      var status = one("[data-pdp-shipping-status]", host);
      var bar = one("[data-pdp-shipping-bar]", host);
      var fill = one("[data-pdp-shipping-fill]", host);
      if (!label || !status || !bar || !fill) return;

      if (!cart || !cart.item_count) {
        label.textContent = "Versandkostenfrei ab " +
          money(threshold, currency) + " in Deutschland";
        status.textContent = "";
      } else if (total >= threshold) {
        label.textContent = "Versandkostenfrei erreicht";
        status.textContent = "";
      } else {
        label.textContent = "Noch " + money(missing, currency) +
          " bis versandkostenfrei";
        status.textContent = "";
      }

      fill.style.transform = "scaleX(" + progress + ")";
      bar.setAttribute("aria-valuenow", String(Math.min(total, threshold)));
      bar.setAttribute(
        "aria-valuetext",
        total >= threshold
          ? "Kostenloser Versand erreicht"
          : money(missing, currency) + " fehlen bis zum kostenlosen Versand",
      );
      host.classList.toggle("is-complete", total >= threshold);
      host.hidden = false;
    }

    function refresh() {
      revision += 1;
      var ownRevision = revision;
      if (controller) controller.abort();
      var ownController = new AbortController();
      controller = ownController;
      var timeout = window.setTimeout(function () {
        ownController.abort();
      }, 8000);
      var cartRequest = typeof window.asifGetCartSnapshot === "function"
        ? window.asifGetCartSnapshot()
        : fetch("/cart.js", {
          credentials: "same-origin",
          headers: { Accept: "application/json" },
          signal: ownController.signal,
        }).then(function (response) {
          if (!response.ok) throw new Error("Cart response " + response.status);
          return response.json();
        });
      Promise.resolve(cartRequest).then(function (cart) {
        if (ownRevision === revision) {
          lastCart = cart;
          paint(cart);
        }
      }).catch(function (error) {
        if (error.name !== "AbortError" && ownRevision === revision && lastCart) {
          paint(lastCart);
        }
      }).finally(function () {
        window.clearTimeout(timeout);
      });
    }

    function queueRefresh() {
      window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(refresh, 30);
    }

    paint(null);
    window.asifPdpRefreshShipping = refresh;
    document.addEventListener("variant:change", function () {
      window.setTimeout(function () {
        paint(lastCart);
      }, 0);
    });
    document.addEventListener("cart:change", function (event) {
      var cart = event.detail && event.detail.cart;
      if (cart) {
        lastCart = cart;
        paint(cart);
      } else {
        queueRefresh();
      }
    });
    document.addEventListener("cart:refresh", queueRefresh);
    window.addEventListener("pageshow", function (event) {
      if (event.persisted) queueRefresh();
    });
    refresh();
  }

  var lastVariantInput = null;

  function normalize(value) {
    return (value || "").trim().toLocaleLowerCase("de-DE");
  }

  function setupColorSwitch() {
    function sync() {
      var activeColor = normalize(selectedColor());
      all("[data-pdp-alt-color]").forEach(function (button) {
        button.hidden =
          normalize(button.getAttribute("data-pdp-alt-color")) === activeColor;
        button.disabled = false;
        button.removeAttribute("aria-busy");
      });
      all("[data-pdp-alt-color-thumb]").forEach(function (thumb) {
        thumb.hidden =
          normalize(thumb.getAttribute("data-pdp-alt-color-thumb")) ===
            activeColor;
      });
    }

    document.addEventListener("click", function (event) {
      var button = event.target.closest &&
        event.target.closest("[data-pdp-alt-color]");
      if (!button) return;
      event.preventDefault();
      var targetColor = normalize(button.getAttribute("data-pdp-alt-color"));
      var picker = one('variant-picker[context="main_product"]');
      var field = picker && one("[data-pdp-color-option]", picker);
      var input = field &&
        all("input[data-option-position]", field).find(function (candidate) {
          var label = candidate.nextElementSibling;
          return label && normalize(label.textContent) === targetColor;
        });
      if (!input) return;
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
      lastVariantInput = input;
      input.checked = true;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    document.addEventListener("variant:change", function () {
      window.setTimeout(sync, 40);
    });
    sync();
  }

  function setupVariantRecovery() {
    var syncState = "ready";

    function pickerAndForm() {
      var picker = one('variant-picker[context="main_product"]');
      var formId = picker && picker.getAttribute("form-id");
      return {
        picker: picker,
        form: formId && (document.getElementById(formId) ||
          document.forms.namedItem(formId)),
      };
    }

    function setSyncState(nextState) {
      syncState = nextState;
      var blocked = nextState !== "ready";
      document.body.classList.toggle(
        "pdp-variant-sync-pending",
        nextState === "pending",
      );
      document.body.classList.toggle(
        "pdp-variant-sync-error",
        nextState === "error",
      );
      var pair = pickerAndForm();
      if (!pair.form) return;

      all('button[type="submit"]').forEach(function (button) {
        if (button.form !== pair.form) return;
        if (blocked) {
          if (!button.hasAttribute("data-asif-sync-disabled")) {
            button.setAttribute("data-asif-sync-disabled", "");
            button.setAttribute(
              "data-asif-sync-was-disabled",
              button.disabled ? "true" : "false",
            );
            button.setAttribute(
              "data-asif-sync-was-aria-disabled",
              button.hasAttribute("aria-disabled")
                ? button.getAttribute("aria-disabled")
                : "__absent__",
            );
          }
          button.disabled = true;
          button.setAttribute("aria-disabled", "true");
          return;
        }
        if (!button.hasAttribute("data-asif-sync-disabled")) return;
        button.disabled =
          button.getAttribute("data-asif-sync-was-disabled") === "true";
        var previousAria = button.getAttribute(
          "data-asif-sync-was-aria-disabled",
        );
        if (previousAria === "__absent__") {
          button.removeAttribute("aria-disabled");
        } else {
          button.setAttribute("aria-disabled", previousAria);
        }
        button.removeAttribute("data-asif-sync-disabled");
        button.removeAttribute("data-asif-sync-was-disabled");
        button.removeAttribute("data-asif-sync-was-aria-disabled");
      });

      var paymentScope = all("buy-buttons[form]", pair.form).find(
        function (buttons) {
          return buttons.getAttribute("form") === pair.form.getAttribute("id");
        },
      );
      (paymentScope ? all(".shopify-payment-button", paymentScope) : []).forEach(function (payment) {
        if (blocked) {
          if (!payment.hasAttribute("data-asif-sync-inert")) {
            payment.setAttribute("data-asif-sync-inert", "");
            payment.setAttribute(
              "data-asif-sync-was-inert",
              payment.hasAttribute("inert") ? "true" : "false",
            );
          }
          payment.setAttribute("inert", "");
          payment.setAttribute("aria-hidden", "true");
          return;
        }
        if (!payment.hasAttribute("data-asif-sync-inert")) return;
        if (payment.getAttribute("data-asif-sync-was-inert") !== "true") {
          payment.removeAttribute("inert");
        }
        payment.removeAttribute("aria-hidden");
        payment.removeAttribute("data-asif-sync-inert");
        payment.removeAttribute("data-asif-sync-was-inert");
      });
    }

    function ensureMessage() {
      var picker = one('variant-picker[context="main_product"]');
      if (!picker) return null;
      var message = one("[data-pdp-variant-error]");
      if (message && message.isConnected) return message;
      message = document.createElement("p");
      message.className = "pdp-variant-error";
      message.hidden = true;
      message.setAttribute("data-pdp-variant-error", "");
      message.setAttribute("role", "alert");
      message.setAttribute("aria-live", "assertive");
      message.innerHTML =
        '<span>Die Auswahl konnte nicht aktualisiert werden.</span><button type="button" data-pdp-variant-retry>Erneut versuchen</button>';
      picker.insertAdjacentElement("afterend", message);
      return message;
    }

    document.addEventListener("change", function (event) {
      if (
        event.target && event.target.matches &&
        event.target.matches("input[data-option-position]") &&
        event.target.closest('variant-picker[context="main_product"]')
      ) {
        lastVariantInput = event.target;
        setSyncState("pending");
        var message = ensureMessage();
        if (message) message.hidden = true;
      }
    }, true);

    document.addEventListener("variant:sync", function (event) {
      var sourcePicker = event.target.closest &&
        event.target.closest('variant-picker[context="main_product"]');
      if (!sourcePicker) return;
      if (event.detail && event.detail.state === "pending") {
        setSyncState("pending");
      }
    });

    document.addEventListener("variant:error", function (event) {
      var sourcePicker = event.target.closest &&
        event.target.closest('variant-picker[context="main_product"]');
      if (!sourcePicker) return;
      setSyncState("error");
      var message = ensureMessage();
      if (message) message.hidden = false;
      all("[data-pdp-alt-color]").forEach(function (button) {
        button.disabled = false;
        button.removeAttribute("aria-busy");
      });
    });

    document.addEventListener("variant:change", function (event) {
      var pair = pickerAndForm();
      var formId = event.detail && event.detail.formId;
      if (!pair.form || (formId
        ? formId !== pair.form.getAttribute("id")
        : event.target !== pair.form)) return;
      setSyncState("ready");
      var message = ensureMessage();
      if (message) message.hidden = true;
    });

    document.addEventListener("click", function (event) {
      var retry = event.target.closest &&
        event.target.closest("[data-pdp-variant-retry]");
      if (!retry || !lastVariantInput || !lastVariantInput.isConnected) return;
      retry.disabled = true;
      setSyncState("pending");
      lastVariantInput.dispatchEvent(new Event("change", { bubbles: true }));
      window.setTimeout(function () {
        retry.disabled = false;
      }, 800);
    });

    document.addEventListener("submit", function (event) {
      var pair = pickerAndForm();
      if (!pair.form || event.target !== pair.form || syncState === "ready") {
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      var message = ensureMessage();
      if (message && syncState === "error") message.hidden = false;
    }, true);

    ensureMessage();
  }

  function setupQuickAddon() {
    function sync() {
      var host = one("[data-pdp-quick-addon]");
      var variantInput = host && one("[data-pdp-addon-variant]", host);
      if (!variantInput) return;
      var color = normalize(selectedColor());
      var variantId = color === "black"
        ? variantInput.getAttribute("data-black-id")
        : variantInput.getAttribute("data-light-id");
      var price = color === "black"
        ? variantInput.getAttribute("data-black-price")
        : variantInput.getAttribute("data-light-price");
      var imageUrl = color === "black"
        ? host.getAttribute("data-black-image")
        : host.getAttribute("data-light-image");
      var button = one('button[type="submit"]', host);
      var priceNode = one("[data-pdp-addon-price]", host);
      var imageNode = one(".pdp-quick-addon__media img", host);
      var available = !!variantId;
      host.hidden = !available;
      if (available) variantInput.value = variantId;
      if (button) {
        button.disabled = !available;
        button.setAttribute("aria-disabled", available ? "false" : "true");
      }
      var priceCopy = price
        ? "+ " + price + " - zusammen versandkostenfrei in DE"
        : "";
      if (priceNode && priceCopy && priceNode.textContent !== priceCopy) {
        priceNode.textContent = priceCopy;
      }
      if (imageNode && imageUrl && imageNode.getAttribute("src") !== imageUrl) {
        imageNode.removeAttribute("srcset");
        imageNode.setAttribute("src", imageUrl);
      }
    }

    document.addEventListener("variant:add", function (event) {
      var host = event.target.closest &&
        event.target.closest("[data-pdp-quick-addon]");
      var button = host && one('button[type="submit"]', host);
      if (!button) return;
      button.textContent = "Dabei";
      window.setTimeout(function () {
        if (button.isConnected) button.textContent = "Dazu";
      }, 2200);
    });
    document.addEventListener("cart:error", function (event) {
      var host = event.target.closest &&
        event.target.closest("[data-pdp-quick-addon]");
      var button = host && one('button[type="submit"]', host);
      if (button) button.textContent = "Dazu";
    });
    document.addEventListener("change", function (event) {
      if (
        event.target && event.target.matches &&
        event.target.matches("input[data-option-position]") &&
        event.target.closest("[data-pdp-color-option]")
      ) {
        sync();
      }
    });
    document.addEventListener("variant:change", sync);
    sync();
  }

  function boot() {
    all("product-gallery").forEach(galleryController);
    setupSpecsDisclosure();
    setupShippingProgress();
    setupColorSwitch();
    setupVariantRecovery();
    setupQuickAddon();
  }

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", boot, { once: true })
    : boot();
})();

/* --- Groesse aus dem Kaufbalken heraus 17.08.2026 --------------------
   Das Panel bedient die echten Radios im Variantenwaehler, es baut
   keine eigene Variantenlogik. Damit bleibt theme.js zustaendig.
--------------------------------------------------------------------- */
(function () {
  "use strict";
  if (!document.body || !document.body.classList.contains("pdp")) return;
  var restoreStickyFocus = false;

  function bar() {
    return document.querySelector(".pdp .product-sticky-bar");
  }
  function group() {
    return document.querySelector(".product-info [data-pdp-size-option]");
  }

  function trigger() {
    var b = bar();
    return b && b.querySelector('button[type="submit"]');
  }

  function restoreFocusAfterChoice() {
    var b = bar();
    var button = trigger();
    if (
      b && button && b.classList.contains("is-asif-visible") &&
      getComputedStyle(button).visibility !== "hidden"
    ) {
      button.focus({ preventScroll: true });
      return;
    }

    /* Wenn der Kaufbalken nach dem Rerender am Footer verschwindet,
       darf der Fokus nicht ins Dokument fallen. Der echte Haupt-CTA ist
       dann das naechste sinnvolle und weiterhin vorhandene Ziel. */
    var picker = document.querySelector('variant-picker[context="main_product"]');
    var formId = picker && picker.getAttribute("form-id");
    var buyButtons = formId && document.querySelector(
      'buy-buttons[form="' + CSS.escape(formId) + '"]',
    );
    var mainButton = buyButtons && buyButtons.querySelector(
      'button[type="submit"][name="add"]',
    );
    if (mainButton) mainButton.focus({ preventScroll: true });
  }

  function setPanelOpen(open) {
    var b = bar();
    var button = trigger();
    var panel = b && b.querySelector(".pdp-bar-size");
    var next = !!(b && panel && open);
    if (b) b.classList.toggle("is-size-open", next);
    document.body.classList.toggle("asif-sticky-size-open", next);
    if (button && panel) {
      button.setAttribute("aria-controls", panel.id);
      button.setAttribute("aria-expanded", next ? "true" : "false");
      button.removeAttribute("aria-haspopup");
    }
  }

  window.asifSetStickySizeOpen = setPanelOpen;

  function sizeChosen() {
    var g = group();
    return !g || !!g.querySelector("input[data-option-position]:checked");
  }

  function build() {
    var b = bar(), g = group();
    if (!b || !g) return null;

    var p = b.querySelector(".pdp-bar-size");
    if (!p) {
      p = document.createElement("div");
      p.className = "pdp-bar-size";
      p.id = "pdp-sticky-size-panel";
      p.setAttribute("role", "group");
      p.setAttribute("aria-label", "Größe wählen");
      p.innerHTML = '<p class="pdp-bar-size__label">Größe wählen</p>' +
        '<ul class="pdp-bar-size__list"></ul>';
      b.appendChild(p);
    }

    var list = p.querySelector(".pdp-bar-size__list");
    list.textContent = "";

    Array.prototype.forEach.call(
      g.querySelectorAll("input[data-option-position]"),
      function (input) {
        var label = input.nextElementSibling;
        var soldout = input.disabled ||
          (label && label.classList.contains("is-disabled"));

        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "pdp-bar-size__item";
        btn.textContent = (label ? label.textContent : input.value).trim();
        btn.setAttribute("aria-pressed", input.checked ? "true" : "false");
        if (soldout) {
          btn.setAttribute("data-soldout", "");
          btn.setAttribute("aria-disabled", "true");
          btn.disabled = true;
        }

        btn.addEventListener("click", function () {
          if (soldout) return;
          restoreStickyFocus = true;
          input.checked = true;
          input.dispatchEvent(new Event("change", { bubbles: true }));
          setPanelOpen(false);
        });

        var li = document.createElement("li");
        li.appendChild(btn);
        list.appendChild(li);
      },
    );

    return p;
  }

  /* Capture-Phase: vor dem Submit-Handler des Themes. */
  document.addEventListener("click", function (e) {
    var b = bar();
    if (!b) return;

    var btn = e.target.closest &&
      e.target.closest('.product-sticky-bar button[type="submit"]');
    if (btn && !sizeChosen()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      build();
      setPanelOpen(!b.classList.contains("is-size-open"));
      return;
    }

    if (
      b.classList.contains("is-size-open") &&
      !e.target.closest(".product-sticky-bar")
    ) {
      setPanelOpen(false);
    }
  }, true);

  document.addEventListener("keydown", function (e) {
    var b = bar();
    if (e.key === "Escape" && b && b.classList.contains("is-size-open")) {
      setPanelOpen(false);
      var button = trigger();
      if (button) button.focus();
    }
  });
  document.addEventListener("variant:change", function (event) {
    if (!restoreStickyFocus) return;
    var mainForm = document.querySelector('variant-picker[context="main_product"]');
    var formId = mainForm && mainForm.getAttribute("form-id");
    if (!formId || !event.detail || event.detail.formId !== formId) return;
    restoreStickyFocus = false;
    window.setTimeout(function () {
      restoreFocusAfterChoice();
    }, 0);
  });
  document.addEventListener("variant:error", function (event) {
    if (!restoreStickyFocus) return;
    var sourcePicker = event.target.closest &&
      event.target.closest('variant-picker[context="main_product"]');
    if (!sourcePicker) return;
    restoreStickyFocus = false;
    restoreFocusAfterChoice();
  });
  setPanelOpen(false);
})();

/* --- Wechsel-Kachel: entfernt 17.08.2026 ---------------------------
   Sass am falschen Platz: sie stand direkt hinter dem ersten Bild und
   damit vor Titel und Preis. Die zweite Farbe steht im Farbwaehler,
   das reicht. Alte Kacheln werden aufgeraeumt, falls noch welche im
   DOM haengen.
--------------------------------------------------------------------- */
(function () {
  "use strict";
  function aufraeumen() {
    var alte = document.querySelectorAll(".pdp-color-switch");
    for (var i = 0; i < alte.length; i++) alte[i].remove();
  }
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", aufraeumen, { once: true })
    : aufraeumen();
  document.addEventListener("variant:change", function () {
    setTimeout(aufraeumen, 80);
  });
})();

/* Die Kaufkarte unten rechts ist entfallen. Die Kaufspalte klebt jetzt
   als ganzer Block, der Kaufbalken unten reicht als zweite Ebene. */

/* --- Kaufbalken: Sichtbarkeit direkt am Scroll 17.08.2026 ------------
   Der IntersectionObserver weiter oben hat die Klasse im Test nicht
   gesetzt. Statt der Fehlersuche im Beobachter entscheidet hier eine
   Messung pro Scroll-Frame: der Balken kommt, sobald der echte
   Kaufknopf mit seiner Unterkante hinter den klebrigen Kopf gelaufen
   ist, und geht wieder, sobald der Footer ins Bild kommt.
--------------------------------------------------------------------- */
(function () {
  "use strict";
  if (!document.body || !document.body.classList.contains("pdp")) return;

  var wartet = false;

  function kopfUnterkante() {
    if (typeof window.asifStickyTop === "function") {
      return window.asifStickyTop();
    }
    var head = document.querySelector(".shopify-section-group-header-group");
    return head ? head.getBoundingClientRect().bottom : 0;
  }

  function pruefen() {
    wartet = false;
    var bar = document.querySelector(".product-sticky-bar");
    if (!bar) return;
    var anker =
      document.querySelector('.product-info [data-block-type="buy-buttons"]') ||
      document.querySelector(".product-info buy-buttons");
    var footer = document.querySelector(".shopify-section--footer") ||
      document.querySelector('[id*="__footer"]');
    if (!anker) return;

    var vorbei = anker.getBoundingClientRect().bottom <= kopfUnterkante();
    var footerDa = footer
      ? footer.getBoundingClientRect().top < window.innerHeight
      : false;
    var an = vorbei && !footerDa;

    if (bar.classList.contains("is-asif-visible") !== an) {
      bar.classList.toggle("is-asif-visible", an);
      if (!an && typeof window.asifSetStickySizeOpen === "function") {
        window.asifSetStickySizeOpen(false);
      }
      hoeheMelden(bar);
    } else if (an) {
      hoeheMelden(bar);
    }
  }

  function anstossen() {
    if (wartet) return;
    wartet = true;
    window.requestAnimationFrame(pruefen);
  }

  /* Hoehe der Kaufkarte fuer den Hilfe-Knopf bereitstellen, damit er sich
     genau um die Karte herum nach oben schiebt statt sie zu ueberdecken. */
  function hoeheMelden(bar) {
    var an = !!(bar && bar.classList.contains("is-asif-visible"));
    var h = an ? Math.round(bar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty("--asif-cta-h", h + "px");
    /* Die Shopify-Vorschauleiste verschiebt den Hilfe-Knopf ueber
       --ci-preview-offset. Der Wert steht nur an #ci-root, also spiegeln
       wir ihn, damit die Kaufkarte in der Vorschau nicht darunter liegt.
       Im Livebetrieb ist er 0. */
    var hub = document.getElementById("ci-root");
    if (hub) {
      /* Die Shopify-Vorschauleiste verschiebt den Hilfe-Knopf ueber
         --ci-preview-offset. Der Wert steht nur an #ci-root, also spiegeln
         wir ihn, damit die Kaufkarte in der Vorschau nicht darunter liegt.
         Im Livebetrieb ist er 0. */
      var off = getComputedStyle(hub).getPropertyValue("--ci-preview-offset")
        .trim();
      document.documentElement.style.setProperty(
        "--asif-preview-off",
        off || "0px",
      );

      /* Hilfe-Knopf ueber die Karte heben. Ueber top, nicht bottom: das
         Widget setzt bottom selbst, top gewinnt bei fester Hoehe. */
      var breit = window.matchMedia("screen and (min-width: 1000px)").matches;
      if (an && breit) {
        var schale = hub.querySelector(".ci-launcher-shell") || hub;
        var kh = schale.getBoundingClientRect().height || 50;
        var kt = bar.getBoundingClientRect().top;
        hub.style.setProperty(
          "top",
          Math.floor(kt - 16 - kh) + "px",
          "important",
        );
        hub.style.setProperty("bottom", "auto", "important");
      } else {
        hub.style.removeProperty("top");
        hub.style.removeProperty("bottom");
      }
    }
    /* Ein gemeinsamer Zustand steuert Hilfe-Knopf und Radio-Dock. */
    document.body.classList.toggle("asif-cta-on", an);
  }

  window.asifPruefeBalken = pruefen;
  window.addEventListener("scroll", anstossen, { passive: true });
  window.addEventListener("resize", anstossen, { passive: true });
  document.addEventListener("variant:change", function () {
    setTimeout(pruefen, 60);
  });

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", pruefen, { once: true })
    : pruefen();
})();

/* --- Farbwechsel ohne Netz 18.08.2026 --------------------------------
   Welche Galeriebilder zu welcher Farbe gehoeren, entscheidet bisher
   allein der Server: die Sektion wird neu gerendert und schickt die
   Bilder mit gesetztem hidden zurueck. Faellt diese Anfrage aus oder
   dauert sie, bleibt die alte Farbe im Bild stehen, waehrend Preis und
   Auswahl schon umgesprungen sind. Genau das war der Aussetzer, den man
   nur manchmal gesehen hat.

   Hier filtern wir sofort im Browser. Grundlage sind die Marker, die die
   Galerie ohnehin schon in die Bildbeschreibung schreibt und die wir als
   data-pdp-media-group / -value am Element ausgeben. Kommt die
   Server-Antwort spaeter doch, ueberschreibt sie das Ergebnis mit
   demselben Inhalt - es gibt kein Hin und Her.
--------------------------------------------------------------------- */
(function () {
  "use strict";

  function alle(sel, wurzel) {
    return Array.prototype.slice.call((wurzel || document).querySelectorAll(sel));
  }

  function normal(text) {
    return String(text || "").trim().toLowerCase();
  }

  function gewaehlteFarbe() {
    var picker = document.querySelector('variant-picker[context="main_product"]');
    var feld = picker && picker.querySelector("[data-pdp-color-option]");
    var input = feld && feld.querySelector("input[data-option-position]:checked");
    var label = input && input.nextElementSibling;
    return label ? normal(label.textContent) : "";
  }

  function filtern() {
    var wert = gewaehlteFarbe();
    if (!wert) return;

    var galerie = document.querySelector("product-gallery");
    if (!galerie) return;

    var zellen = alle("[data-pdp-media-group]", galerie);
    if (!zellen.length) return;

    /* Die Gruppe bestimmen wir aus den Daten selbst, damit die Regel auch
       dann greift, wenn die Option im Shop anders heisst als hier erwartet. */
    var gruppe = null;
    zellen.forEach(function (zelle) {
      if (gruppe) return;
      if (normal(zelle.getAttribute("data-pdp-media-value")) === wert) {
        gruppe = normal(zelle.getAttribute("data-pdp-media-group"));
      }
    });
    if (!gruppe) return;

    var sichtbar = 0;
    zellen.forEach(function (zelle) {
      if (normal(zelle.getAttribute("data-pdp-media-group")) !== gruppe) return;
      var passt = normal(zelle.getAttribute("data-pdp-media-value")) === wert;
      zelle.hidden = !passt;
      if (passt && zelle.classList.contains("product-gallery__media")) sichtbar++;
    });

    /* Sicherung: bliebe die Galerie leer, machen wir nichts kaputt. */
    if (!sichtbar) {
      zellen.forEach(function (zelle) {
        if (normal(zelle.getAttribute("data-pdp-media-group")) === gruppe) {
          zelle.hidden = false;
        }
      });
      return;
    }

    var karussell = galerie.querySelector(".product-gallery__carousel");
    var erste = galerie.querySelector(".product-gallery__media:not([hidden])");
    if (karussell && erste) {
      karussell.scrollLeft = erste.offsetLeft;
      karussell.dispatchEvent(new Event("scroll", { bubbles: false }));
    }
    alle(".product-gallery__thumbnail", galerie).forEach(function (knopf) {
      knopf.setAttribute("aria-current", "false");
    });
    var ersterThumb = galerie.querySelector(
      ".product-gallery__thumbnail:not([hidden])",
    );
    if (ersterThumb) ersterThumb.setAttribute("aria-current", "true");
  }

  function anstossen() {
    window.setTimeout(filtern, 0);
    window.setTimeout(filtern, 260);
  }

  document.addEventListener("change", function (event) {
    var input = event.target;
    if (!input || !input.matches) return;
    if (!input.matches("input[data-option-position]")) return;
    if (!input.closest("[data-pdp-color-option]")) return;
    anstossen();
  }, true);

  document.addEventListener("variant:change", anstossen);

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", filtern, { once: true })
    : filtern();
})();
